import React, { useEffect, useState } from "react";
import Card from "components/card";
import Button from "components/button";
import { getDocuments, deleteDocument } from "services/documents";
import { useNavigate } from "react-router-dom";

const Documents = () => {
  const [documents, setDocuments] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const load = async () => {
      try {
        const { data } = await getDocuments();
        setDocuments(Array.isArray(data?.data) ? data.data : []);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  const handleDelete = async (id: number) => {
    if (!window.confirm("Delete document?")) return;
    try {
      await deleteDocument(id);
      setDocuments((prev) => prev.filter((d) => d.id !== id));
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <Card extra="w-full p-4">
      <div className="mb-6 flex flex-col sm:flex-row sm:items-center sm:justify-between">
        <h2 className="text-2xl font-bold text-gray-900">Documents</h2>
        <div className="mt-3 sm:mt-0">
          <Button as="link" to="/admin/documents/create">
            Upload Document
          </Button>
        </div>
      </div>
      {loading ? (
        <p>Loading...</p>
      ) : documents.length === 0 ? (
        <p className="text-gray-500">No documents yet.</p>
      ) : (
        <div className="space-y-4">
          {documents.map((doc) => (
            <div
              key={doc.id}
              className="flex flex-col rounded bg-white p-4 shadow-sm dark:bg-navy-700 md:flex-row md:items-center md:justify-between"
            >
              <div>
                <h3 className="font-semibold">{doc.title}</h3>
                <p className="text-sm text-gray-600 dark:text-gray-300">
                  Uploaded by {doc.uploader?.firstname} {doc.uploader?.lastname}
                </p>
              </div>
              <div className="mt-3 flex items-center space-x-2 md:mt-0">
                <a
                  href={doc.download_url || `/storage/${doc.file_path}`}
                  className="text-indigo-600"
                >
                  Download
                </a>
                <Button
                  size="sm"
                  variant="danger"
                  onClick={() => handleDelete(doc.id)}
                >
                  Delete
                </Button>
              </div>
            </div>
          ))}
        </div>
      )}
    </Card>
  );
};

export default Documents;
